import { render, staticRenderFns } from "./history-reports.vue?vue&type=template&id=506fa34b&scoped=true"
import script from "./history-reports.vue?vue&type=script&lang=js"
export * from "./history-reports.vue?vue&type=script&lang=js"
import style0 from "./history-reports.vue?vue&type=style&index=0&id=506fa34b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fa34b",
  null
  
)

export default component.exports